module.exports = __webpack_public_path__ + "img/xgcl.d19bccc0.png";